<template>
  <div :class="['side-nav', { 'side-nav-expanded': isExpanded }]">
    <button @click="toggleNav" class="toggle-btn">
      <i :class="isExpanded ? 'bi bi-x' : 'bi bi-list'"></i>
    </button>
    <ul class="list-unstyled">
      <li>
        <router-link to="/" class="nav-item d-flex align-items-center">
          <i class="bi bi-house-door"></i>
          <span v-if="isExpanded" class="ms-2">Home</span>
        </router-link>
      </li>
      <li>
        <router-link to="/bot_test" class="nav-item d-flex align-items-center">
          <i class="bi bi-robot"></i>
          <span v-if="isExpanded" class="ms-2">Bot Test</span>
        </router-link>
      </li>
      <li>
        <router-link to="/manipulation" class="nav-item d-flex align-items-center">
          <i class="bi bi-controller"></i>
          <span v-if="isExpanded" class="ms-2">Manipulation</span>
        </router-link>
      </li>
      <li v-show="role > 1">
        <router-link to="/camera_streaming" class="nav-item d-flex align-items-center">
          <i class="bi bi-camera-video"></i>
          <span v-if="isExpanded" class="ms-2">Camera Streaming</span>
        </router-link>
      </li>
      <li v-show="role > 1">
        <router-link to="/mobile_manipulator" class="nav-item d-flex align-items-center">
          <i class="bi bi-cart"></i>
          <span v-if="isExpanded" class="ms-2">Mobile Manipulator</span>
        </router-link>
      </li>
      <li v-show="role > 1">
        <router-link to="/ufb" class="nav-item d-flex align-items-center">
          <i class="bi bi-people"></i>
          <span v-if="isExpanded" class="ms-2">UFB</span>
        </router-link>
      </li>

    </ul>
  </div>
</template>

<script>
export default {
  name: 'SideNav',
  data() {
    return {
      role: 0,
      isExpanded: false,
    };
  },
  created() {
    this.role = this.$USER.role;
  },
  methods: {
    toggleNav() {
      this.isExpanded = !this.isExpanded;
    }
  }
};
</script>

<style scoped>
.side-nav {
  width: 50px;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #333;
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1060;
}

.side-nav-expanded {
  width: 200px;
  align-items: flex-start;
}

.side-nav .nav-item {
  color: white;
  text-decoration: none;
  padding: 10px;
  width: 100%;
}

.side-nav .nav-item i {
  margin-right: 10px;
  font-size: 1.2rem;
}

.side-nav .nav-item:hover {
  background-color: #575757;
}

.toggle-btn {
  background-color: #333;
  color: white;
  border: none;
  padding: 10px;
  width: 100%;
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  justify-content: center;
}
</style>
